export const AUTH_DATA = 'AUTH_DATA';
